module.exports = __webpack_public_path__ + "static/media/bg-pontos.2ce78e42.svg";